import useLastCallServiceCompany from '../queries/useLastCallServiceCompany';
import usePhoneFieldCallHandler from './usePhoneFieldCallHandler';
import {
  phoneFieldValueSelector,
  serviceCompanyValueSelector,
} from '../store/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { formatPhoneNumber } from '../../../helpers/formatPhoneNumber';
import { setCompanyVisible } from '../store/actions';

const useCallHandler = () => {
  const phoneFieldValue = useSelector(phoneFieldValueSelector);
  const serviceCompany = useSelector(serviceCompanyValueSelector);

  const dispatch = useDispatch();

  const { handleCall } = usePhoneFieldCallHandler();

  const { handleGetLastCallServiceCompany, isLoading } =
    useLastCallServiceCompany();

  const handleClickCall = async () => {
    if (phoneFieldValue.trim()) {
      const formattedPhoneNum = formatPhoneNumber({
        phoneNumber: phoneFieldValue,
      });

      const lastCompany = await handleGetLastCallServiceCompany(
        String(formattedPhoneNum)
      );

      const isLastCompanyEmpty = !lastCompany;

      const isLastCompanyRequired = lastCompany?.id === serviceCompany?.id;

      if (isLastCompanyEmpty || isLastCompanyRequired) {
        handleCall();
        return;
      }

      dispatch(setCompanyVisible(lastCompany));
    }

    return;
  };

  return {
    handleClickCall,
    isLoading,
  };
};

export default useCallHandler;
